import { render, staticRenderFns } from "./Buy.vue?vue&type=template&id=01b25a92&scoped=true&"
import script from "./Buy.vue?vue&type=script&lang=js&"
export * from "./Buy.vue?vue&type=script&lang=js&"
import style0 from "./Buy.vue?vue&type=style&index=0&id=01b25a92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b25a92",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
